/**
 * Format price with proper decimals
 */
export function formatPrice(price, decimals = 2) {
  if (price == null) return '--'
  return Number(price).toFixed(decimals)
}

/**
 * 按品种返回价格小数位：白银(XAGUSD/含"白银") 3 位，其余 2 位
 * 支持传入品种代码或中文名称
 */
export function priceDecimals(symbol) {
  const s = String(symbol == null ? '' : symbol)
  return (s === 'XAGUSD' || s.indexOf('白银') !== -1) ? 3 : 2
}

/**
 * Format change percentage
 */
export function formatChgPct(pct) {
  if (pct == null) return '--'
  const sign = pct > 0 ? '+' : ''
  return `${sign}${Number(pct).toFixed(2)}%`
}

/**
 * Format large numbers
 */
export function formatNumber(num) {
  if (num == null) return '--'
  return Number(num).toLocaleString()
}

/**
 * Format timestamp to date string
 */
export function formatDate(timestamp, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!timestamp) return '--'
  const d = new Date(timestamp)
  const map = {
    'YYYY': d.getFullYear(),
    'MM': String(d.getMonth() + 1).padStart(2, '0'),
    'DD': String(d.getDate()).padStart(2, '0'),
    'HH': String(d.getHours()).padStart(2, '0'),
    'mm': String(d.getMinutes()).padStart(2, '0'),
    'ss': String(d.getSeconds()).padStart(2, '0')
  }
  return fmt.replace(/YYYY|MM|DD|HH|mm|ss/g, m => map[m])
}

/**
 * Toast helper
 */
export function showToast(msg, duration = 2000) {
  let el = document.getElementById('ftx-toast')
  if (!el) {
    el = document.createElement('div')
    el.id = 'ftx-toast'
    el.className = 'toast'
    document.body.appendChild(el)
  }
  el.textContent = msg
  el.classList.add('show')
  clearTimeout(el._timer)
  el._timer = setTimeout(() => el.classList.remove('show'), duration)
}

/**
 * Copy text to clipboard
 */
export function copyText(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => showToast('复制成功'))
  } else {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.position = 'fixed'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
    showToast('复制成功')
  }
}

/**
 * 将后端返回的图片路径转为可访问的完整 URL
 * - 完整 URL (http/https) → 提取 pathname，提取 /profile/ 部分直接返回
 * - /profile/ 开头 → 直接返回（Nginx 直接路由）
 * - /dev-api/profile/ 开头 → 去掉 /dev-api 前缀
 * - /api/profile/ 开头 → 去掉 /api 前缀
 * 
 * 开发环境：/profile/upload/xxx.jpg → devServer 代理 → backend
 * 生产环境：/profile/upload/xxx.jpg → nginx location /profile/ → backend StaticFiles
 */
export function getFullImageUrl(src) {
  if (!src) return ''
  if (src.startsWith('data:')) return src
  // 完整 URL：提取 pathname
  if (src.startsWith('http://') || src.startsWith('https://')) {
    try {
      const urlObj = new URL(src)
      const pathname = urlObj.pathname
      // 提取 /profile/ 以后的部分
      const profileIdx = pathname.indexOf('/profile/')
      if (profileIdx >= 0) return pathname.substring(profileIdx)
      // 没有 /profile/ 的完整路径，原样返回
      return pathname
    } catch (e) {
      return src
    }
  }
  // 已经是 /profile/ 开头，直接返回
  if (src.startsWith('/profile/')) return src
  // 去掉 /dev-api/ 或 /api/ 前缀
  if (src.startsWith('/dev-api/profile/')) return src.replace('/dev-api', '')
  if (src.startsWith('/api/profile/')) return src.replace('/api', '')
  // 其他相对路径（如 /profile/upload/xxx.jpg）
  if (src.startsWith('/')) return src
  return '/' + src
}
